import {
  applyForDip,
  canDoDip,
  canDoDipNoProperty,
  doFMA,
  doSolicitorSearch,
  getAcreDipCertBasedOnAffordability,
  getAcreDipCertBasedOnLenderDip,
  getDipCert,
  getDipStatus,
  getDoc,
  getFMAFields,
  submitDip,
  submitNoPropertyDip,
} from '../api/dip'
import {
  DipApplicationError,
  FmaFieldsResponse,
  LbgDipInput,
  Resolvers,
  SubmitDip,
  SubmitLbgDip,
} from '../generated/resolvers'

const transformLBGDipInput = (input: LbgDipInput) => {
  const { client, ...rest } = input

  return {
    ...rest,
    ...client.reduce(
      (acc, client, index) => ({
        ...acc,
        ...Object.keys(client).reduce(
          (clientAcc, key) => ({
            ...clientAcc,
            [`client${index}${key}`]: JSON.stringify(client[key as keyof typeof client]),
          }),
          {},
        ),
      }),
      {},
    ),
  }
}

const resolvers: Resolvers = {
  Mutation: {
    submitDip: async (_parent, { payloadInput, queryInput }) => await submitDip<SubmitDip>(payloadInput, queryInput),
    submitLBGDip: async (_parent, { payloadInput, queryInput }) => {
      const transformedInput = transformLBGDipInput(queryInput)
      return await submitDip<SubmitLbgDip>(payloadInput, transformedInput as LbgDipInput)
    },
    submitNoPropertyDip: async (_parent, { payloadInput, queryInput }) =>
      await submitNoPropertyDip(payloadInput, queryInput),
    getDipCert: async (_parent, { id, mortgageId, case: _case }) => await getDipCert(id, _case, mortgageId),
    getDipDocument: async (_parent, { id, mortgageId, case: _case, documentType: documentType }) =>
      await getDoc(id, _case, mortgageId, documentType!),
    doFMA: async (_parent, { input }) => await doFMA(input),
    getAcreDipCertBasedOnLenderDip: async (_parent, { case: _case, mortgage }) =>
      await getAcreDipCertBasedOnLenderDip(_case, mortgage),
    getAcreDipCertBasedOnAffordability: async (_parent, { case: _case }) =>
      await getAcreDipCertBasedOnAffordability(_case),
  },
  Query: {
    canDoDip: async (_parent, { input }) => await canDoDip(input),
    canDoDipNoProperty: async (_parent, { input }) => await canDoDipNoProperty(input),
    getDipStatus: async (_parent, { input }) => await getDipStatus(input),
    applyForDip: async (_parent, { id, mortgageId, reservation }) => await applyForDip(id, mortgageId, reservation),
    fmaFields: async (_parent, { caseId, mortgageId }) => await getFMAFields(caseId, mortgageId),
    solicitorSearch: async (_parent, { q }) => await doSolicitorSearch(q),
  },
  FMAFields: {
    __resolveType(obj) {
      if ((obj as FmaFieldsResponse).dip_available) {
        return 'FMAFieldsResponse'
      }
      if ((obj as DipApplicationError).errors) {
        return 'DipApplicationError'
      }
      return null
    },
  },
  FMAResponse: {
    __resolveType(obj) {
      if ((obj as DipApplicationError).errors) {
        return 'DipApplicationError'
      }
      return 'ApplicationResponse'
    },
  },
}

export default resolvers
